// Swagger
export const GET_SWAGGER_REQUEST = 'GET_SWAGGER_REQUEST';
export const GET_SWAGGER_DONE = 'GET_SWAGGER_DONE';
export const GET_SWAGGER_FAILED = 'GET_SWAGGER_FAILED';